<template>
  <div>
    <div class="bj-topic-header"></div>
    <div class="box">
      <ul class="box_title">
        <li>{{ time }}</li>
        <!-- 下划线 -->
        <li class="line"></li>
        <li class="box_title_title">预警日报</li>
      </ul>
      <!-- 边框 -->
      <borFrame :title="'预警概述'">
        <div class="borFrame_content">
          自{{ time }}00:00:00到23:59:59共为您下发系统预警{{ num }}条，较于昨日增加{{ addNum > 0 ? addNum : 0 }}条。
        </div>
      </borFrame>
      <warningPush @updateList="getList"></warningPush>
      <warningSource></warningSource>
      <warningProg></warningProg>
      <!-- <warningMedium></warningMedium> -->
      <warningKeynote></warningKeynote>
    </div>
  </div>
</template>

<script>
import borFrame from "@/components/frame";
import warningPush from './warning/push.vue'
import warningSource from './warning/source.vue'
import warningProg from './warning/programme.vue'
import warningMedium from './warning/medium.vue'
import warningKeynote from './warning/keynote.vue'
import moment from 'moment';
export default {
  components: {
    borFrame,
    warningPush,
    warningSource,
    warningProg,
    warningMedium,
    warningKeynote
  },
  data() {
    return {
      time: '',
      num: 0,
      addNum: 0
    }
  },
  mounted() {
    // this.getList();
    this.time = this.$route.query.time;
  },
  methods: {
    moment,
    // 获取预警推送总览
    getList(val, val1) {
      this.num = val;
      this.addNum = val1;
    }
  }
}
</script>
 
<style lang = "less" scoped>
.bj-topic-header {
  /* 背景颜色从上到下黄色到白色渐变 */
  background: linear-gradient(to bottom, #e9791c, #fff);
  height: 240px;
  width: 100%;
  position: absolute;
  top: 0;
}

.box {
  position: relative;
  width: 100%;
  z-index: 2;

  .box_title {
    margin-top: 6vh;
    color: #fff;
    font-size: .18rem;
    width: 50%;
    margin-left: 50%;
    font-weight: 600;
    text-align: center;

    .line {
      margin: 10px 0;
      border-bottom: 3px solid #fff;
    }

    .box_title_title {
      font-size: .3rem;
    }
  }

  .borFrame_content {
    /* 文字内容之间的间距 */
    letter-spacing: 1px;
    line-height: 1.5;
    display: flex;
    flex-wrap: wrap;
  }
}
</style>